import { useEffect } from 'react';

const isIgnoredElement = (e, ignoredClassName) => {
  if (
    e.target.className ===
    'react-datepicker__navigation react-datepicker__navigation--next'
  ) {
    return true;
  }
  if (e.target.classList.contains(ignoredClassName)) {
    return true;
  }
  return false;
};

const useOutsideClick = (
  ref,
  callback,
  ignoredClassName = 'ignore-onClickOutside',
  type = 'mousedown',
) => {
  const handleClick = (e) => {
    if (
      ref.current &&
      !ref.current.contains(e.target) &&
      !isIgnoredElement(e, ignoredClassName)
    ) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener(type, handleClick);

    return () => {
      document.removeEventListener(type, handleClick);
    };
  }, [ref, callback, ignoredClassName]);
};

export default useOutsideClick;
